/** Mirrors operator-service DATA_REPAIR_UI_MAX_DISPLAY_ROWS (WCO-3277). */
export const DATA_REPAIR_UI_MAX_DISPLAY_ROWS = 50;
